import { mapActions, mapState } from 'vuex'
import formInput from '@/components/common/form-input/form-input.vue'
import formButton from '@/components/common/form-button/form-button.vue'
import Multiselect from 'vue-multiselect'
import router from '@/router'

export default {
  components: {
    formInput,
    formButton,
    Multiselect
  },
  data() {
    return {
      option: {
        text: null,
        country: null
      }
    }
  },
  computed: {
    ...mapState('countries', ['countriesList']),
    ...mapState('attributesTypes', ['currentlyEditedAttribute'])
  },
  methods: {
    ...mapActions('attributesOptions', ['createAttributesOption', 'getAttributesOptionsList']),
    createOption: async function () {
      try {
        await this.createAttributesOption({
          text: this.option.text,
          value: this.option.text,
          type_id: this.currentlyEditedAttribute.id,
          country_id: this.option.country ? this.option.country.id : null
        })
        await this.getAttributesOptionsList({ type: this.currentlyEditedAttribute.name })
        this.$notify({
          text: 'option created',
          type: 'success'
        })
        router.push({ name: 'attribute-edit' })
      } catch (e) {
        this.$notify({
          text: 'Error while creating option',
          type: 'error'
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main-pages/settings/attributes/option-add/option-add.js